export default __webpack_public_path__ + "static/media/logo.1780ee46.png";